import { useState, useEffect, Fragment } from 'react';
import './ReportCreditsIndicator.css';
import ProgressBar from '../../progressBar/ProgressBar';
import { useStateValue } from '../../../StateProvider';
import { GetUserSubscription } from '../../../Services';

const ReportCreditsIndicator = () => {
	const [ { user }, dispatch ] = useStateValue();
	const [ userSubscription, setUserSubscription ] = useState();

	useEffect(() => {
		getUserSubscription();
	}, []);

	const getUserSubscription = async () => {
		let response = await GetUserSubscription(user.id);

		if (response) {
			setUserSubscription(response);
		}
	};

	return (
		<Fragment>
			{userSubscription &&
			userSubscription.subscription && (
				<div className="report-credits-indicator-container">
					<div className="mb-2">Credits Left:</div>

					<div className="indicator-item">
						<div className="indicator-label">{`Grids ${userSubscription.gridReportCredits}/${userSubscription
							.subscription.totalGridReports}`}</div>
						<div className="indicator-bar">
							<ProgressBar
								value={userSubscription.gridReportCredits}
								maxValue={userSubscription.subscription.totalGridReports}
							/>
						</div>
					</div>
					<div className="indicator-item">
						<div className="indicator-label">{`Audits ${userSubscription.auditReportCredits}/${userSubscription
							.subscription.totalAuditReports}`}</div>
						<div className="indicator-bar">
							<ProgressBar
								value={userSubscription.auditReportCredits}
								maxValue={userSubscription.subscription.totalAuditReports}
							/>
						</div>
					</div>
					<div className="indicator-item">
						<div className="indicator-label">{`Campaigns ${userSubscription.campaignCredits}/${userSubscription
							.subscription.totalCampaigns}`}</div>
						<div className="indicator-bar">
							<ProgressBar
								value={userSubscription.campaignCredits}
								maxValue={userSubscription.subscription.totalCampaigns}
							/>
						</div>
					</div>
				</div>
			)}
		</Fragment>
	);
};

export default ReportCreditsIndicator;
